import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const stopCopScan = api(async function stopCopScan({ codeOfPracticeId }) {
    return mutate(
        gql`
            mutation StopCopScan($codeOfPracticeId: ID!) {
                stopCopScan(codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { codeOfPracticeId },
        { returns: "stopCopScan" }
    )
})
